import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';
import { saveAs } from 'file-saver/FileSaver';
@Component({
  selector: 'app-details-payments',
  templateUrl: './details-payments.component.html',
  styleUrls: ['./details-payments.component.scss']
})
export class DetailsPaymentsComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  info: any = {};
  editId: any;
  numOrder: any;
  txtHeader: any;
  dataCharges: any = {};
  listCharges = [];
  approvation:false;
  rejectedStep=1;
  constructor(private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public dialog: MatDialog, public dialogRef: MatDialogRef<DetailsPaymentsComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = this.data.type;
    this.numOrder = this.data.oc;
    this.editId = this.data.id;
    this.approvation = this.data.approve;
    console.log(" payments", this.approvation);    
    this.info = this.data.info;
    this.txtHeader = 'DETAILS';
    console.log(this.info)
   }

   ngOnInit() {
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

  onCloseCancel() {

    console.log('click para cerrar')
    this.dialogRef.close();
  }

  addCharge(){
    if(!this.dataCharges.descripcion ||  !this.dataCharges.importe ){
      this.toastr.info('Todos los campos son requeridos', '');
      return;
    }

    this.dataCharges.no = this.listCharges.length+1;
    this.listCharges.push(this.dataCharges);
    this.dataCharges = {};
  }

  charges(){
    console.log(this.listCharges);
    this.dialogRef.close({ listCharges: this.listCharges });
  }

  downLoadFile(){
    this.editId
    this.provService.downloadFiles(this.editId, '').then((res:any)=>{
      this.loadBtn = false;
      console.log(res.resultado.Entidad );
      if(res.resultado){


        if(res.Entidad.esPdf || res.Entidad.esXml ){
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });

          let mimeType;
          if(!res.Entidad.esZip){
            mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
          }else{
            mimeType =  '.zip';
          }

          let fileName= Date.now();
          let tempName = fileName+mimeType;

          saveAs(blob, tempName);
        }
      }

    })
    // let file = event.target.files[0];


    // let reader = new FileReader();
    // if(event.target.files && event.target.files.length > 0) {
    //   let file = event.target.files[0];
    //   reader.readAsDataURL(file);
    //   reader.onload = () => {

    //     let base64Image = 'data:'+ file.type +';base64,'+reader.result.split(',')[1];
    //     //this.imagenGrupoPrivado = base64Image;

    //   };
    // }



  }

  download(id, idx){
    console.log(id, idx);
    this.provService.downloadHistoryComplement(id, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      if(data['respuestaExitosa']){
        const sampleBytes = this.base64ToArrayBuffer(data['File'].FileContent);
        const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
        saveAs(blob, data['File'].FileName);
      }else{
        this.toastr.info('No se puede descargar el archivo', 'Descargar historial');
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.info('No se puede descargar el archivo', 'Descargar historial');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  removeItem(position){
    this.listCharges.splice(position, 1);
  }

  aprobation:any={};

  rejectedInvoice(){
    this.aprobation.Aprobar = false;
    this.rejectedStep=2;
  }

  approve(){
    this.aprobation.Aprobar = true;
    this.saveAprobation();
  }

  saveAprobation(){
    this.aprobation.IdUsuario = this.data.userId ;
    this.aprobation.GuidRecepcionFactura = this.editId;
    this.provService.approveInvoice(this.aprobation, '123').then((res:any)=>{
      if(res.EsValido){
        this.dialogRef.close({ data: true });
      }else{
        this.toastr.error(res.MensajeUsuario ,'Error');
      }
    });
  }

  downloadDetail(fieldUUID){
    //let fieldUUID = this.listOrders[pos].RecepcionFactura.UUID;

    this.provService.downloadFiles( fieldUUID,'111').then((res:any) => {

      if(res.resultado){
        if(res.Entidad.esPdf || res.Entidad.esXml ){
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });

          let mimeType;
          if(!res.Entidad.esZip){
            mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
          }else{
            mimeType =  '.zip';
          }

          let fileName= Date.now();
          let tempName = fileName+mimeType;
          console.log(tempName);
          saveAs(blob, tempName);
        }else{
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
          let mimeType =  '.zip';

          let fileName= Date.now();
          let tempName = fileName+mimeType;
          console.log(tempName);
          saveAs(blob, tempName);
        }
      }
    });
  }

}
